import { PAGE_ROUTES, TOP_ROUTES } from './routes';

export const pageKey = {
	clientSummary: 'client-summary',
	operationsManual: 'operations-manual',
	notification: 'notification',
	providerServiceAgreement: 'provider-service-agreement',
	practitionerServiceAgreement: 'practitioner-service-agreement',
	valueAddedProgram: 'value-added-program',
	newsletter: 'newsletter',
	frequentlyAskedQuestion: 'frequently-asked-question',
	CPSAnnualReview: 'cps-annual-review',
	resourcesForm: 'resources-form',
	home: 'home',
	search: 'search',
	memberReferral: 'member-referral',
	batchClaimsUpload: 'batch-claim-upload',
	batchClaimsSummary: 'batch-claim-summary',
	ASHClearinghouse: 'ash-clearinghouse',
	compliance: 'compliance',
	ASHLinkWebsiteTip: 'ashlink-website-tip',
	contactUs: 'contact-us',
	submitAnOnlineQuestionOrComment: 'submit-question-or-comment',
	providerEducationLibrary: 'provider-education-library',
	practitionerEducationLibrary: 'practitioner-education-library',
	accountManagement: 'account-management',
	messageCenter: 'message-center',
	transactionSummary: 'transaction-summary',
	favoriteCPTCode: 'favorite-cpt-code',
	confirmUpdateInformation: 'confirm-update-information',
	privacyStatement: 'privacy-statement',
	termsAndCondition: 'terms-and-condition',
	newPatientSearch: 'new-patient-search',
	existingPatientSearch: 'existing-patient-search',
	paymentsSearch: 'payment-search',
	claimsSearch: 'claim-search',
	MNRFormSearch: 'mnr-search',
	reopenModificationsSearch: 'reopen-modifications-search',
	remittanceAdviceSearch: 'remittance-advice-search',
	ashcare: 'ashcare',
	providerPractitionerVirtualServicesAgreement:
		'provider-practitioner-virtual-services-agreement',
	manageSubAccounts: 'manage-sub-accounts',
	updateInfo: 'update-info',
	memberAgreements: 'member-agreements',
	logOut: 'log-out',
	practitionerStatusChangeRequest: 'practitioner-status-change-request',
	switchClinic: 'doctor-switch-clinic',
	confirmClinic: 'confirm-clinic',
	createSubAccount: 'create-sub-account',
	editSubAccounts: 'edit-sub-accounts',
	emnr: 'emnr-submit',
	// Identity
	identity: 'identity',
	healthPlanMemberSearch: 'health-plan-member-search',
};

export const permissionName = {
	general: 'General',
	existingPatient: 'ExistingPatient',
	batchClaim: 'BatchClaim',
	memberReferral: 'MemberReferral',
	clientSummary: 'ClientSummary',
	valueAddedProgram: 'ValueAddedProgram',
	favoriteCPTCode: 'FavoriteCPTCode',
	fallPreventionAssessment: 'FallPreventionAssessment',
	fraudWasteAbuseOnlineAttestation: 'FraudWasteAbuseOnlineAttestation',
	functionalOutcomeMeasure: 'FunctionalOutcomeMeasure',
	GeneralComplianceOnlineAttestation: 'GeneralComplianceOnlineAttestation',
	activitySummary: 'ActivitySummary',
	operationManual: 'OperationManual',
	eClaim: 'EClaim',
	form: 'Form',
	CPSLetter: 'CPSLetter',
	notification: 'Notification',
	newsletter: 'Newsletter',
	clearinghouse: 'Clearinghouse',
	compliance: 'Compliance',
	messageCenter: 'MessageCenter',
	generalUserInformation: 'GeneralUserInformation',
	newPatient: 'NewPatient',
	MNR: 'MNR',
	claim: 'Claim',
	payment: 'Payment',
	NPI: 'NPI',
	providerEducationLibraryAboutASH: 'ProviderEducationLibraryAboutASH',
	providerEducationLibraryAdminTopics: 'ProviderEducationLibraryAdminTopics',
	providerEducationLibraryClinicalTopics:
		'ProviderEducationLibraryClinicalTopics',
	providerEducationLibraryEvidenceEvaluationCommittee:
		'ProviderEducationLibraryEvidenceEvaluationCommittee',
	providerEducationLibraryPatientEducation:
		'ProviderEducationLibraryPatientEducation',
	providerEducationLibraryPolicy: 'ProviderEducationLibraryPolicy',
	providerEducationLibraryProfessionalAffairsHealthcareAdvisoryCommittee:
		'ProviderEducationLibraryProfessionalAffairsHealthcareAdvisoryCommittee',
	providerEducationLibraryVideoSeries: 'ProviderEducationLibraryVideoSeries',
	providerPractitionerVirtualServicesAgreement:
		'ProviderPractitionerVirtualServicesAgreement',
	providerValidation: 'ProviderValidation',
	providerServiceAgreement: 'ProviderServiceAgreement',
	providerStatusChangeRequest: 'ProviderStatusChangeRequest',
	practitionerValidation: 'PractitionerValidation',
	practitionerServiceAgreement: 'PractitionerServiceAgreement',
	practitionerStatusChangeRequest: 'PractitionerStatusChangeRequest',
	practitionerEducationLibraryAboutASH:
		'PractitionerEducationLibraryAboutASH',
	practitionerEducationLibraryAdminTopics:
		'PractitionerEducationLibraryAdminTopics',
	practitionerEducationLibraryClinicalTopics:
		'PractitionerEducationLibraryClinicalTopics',
	practitionerEducationLibraryEvidenceEvaluationCommittee:
		'PractitionerEducationLibraryEvidenceEvaluationCommittee',
	practitionerEducationLibraryPatientEducation:
		'PractitionerEducationLibraryPatientEducation',
	practitionerEducationLibraryPolicy: 'PractitionerEducationLibraryPolicy',
	practitionerEducationLibraryProfessionalAffairsHealthcareAdvisoryCommittee:
		'PractitionerEducationLibraryProfessionalAffairsHealthcareAdvisoryCommittee',
	practitionerEducationLibraryVideoSeries:
		'PractitionerEducationLibraryVideoSeries',
	linkedUser: 'LinkedUser',
	ASHCareSSO: 'ASHCareSSO',
	EMNR: 'EMNR',
	healthPlanMemberSearch: 'HealthPlanMemberSearch',
	help: 'Help',
	xRayReferrals: 'XRayReferrals',
};

export const permissionOperation = {
	read: 'Read',
	createUpdate: 'CreateUpdate',
	delete: 'Delete',
};

const key = pageKey;
const name = permissionName;
const op = permissionOperation;

export const retrievePermissionWithKey = {
	[`${key.editSubAccounts}`]: [`${name.linkedUser}:${op.createUpdate}`],
	[`${key.createSubAccount}`]: [`${name.linkedUser}:${op.createUpdate}`],
	[`${key.confirmClinic}`]: [`${name.general}:${op.read}`],
	[`${key.switchClinic}`]: [`${name.general}:${op.read}`],
	[`${key.clientSummary}`]: [`${name.clientSummary}:${op.read}`],
	[`${key.valueAddedProgram}`]: [`${name.valueAddedProgram}:${op.read}`],
	[`${key.home}`]: [`${name.general}:${op.read}`],
	[`${key.contactUs}`]: [`${name.help}:${op.read}`],
	[`${key.termsAndCondition}`]: [`${name.general}:${op.read}`],
	[`${key.privacyStatement}`]: [`${name.general}:${op.read}`],
	[`${key.frequentlyAskedQuestion}`]: [`${name.help}:${op.read}`],
	[`${key.ASHLinkWebsiteTip}`]: [`${name.help}:${op.read}`],
	[`${key.batchClaimsSummary}`]: [`${name.batchClaim}:${op.read}`],
	[`${key.batchClaimsUpload}`]: [`${name.batchClaim}:${op.createUpdate}`],
	[`${key.memberReferral}`]: [`${name.memberReferral}:${op.read}`],
	[`${key.favoriteCPTCode}`]: [`${name.favoriteCPTCode}:${op.read}`],
	[`${key.transactionSummary}`]: [`${name.activitySummary}:${op.read}`],
	[`${key.providerServiceAgreement}`]: [
		`${name.providerServiceAgreement}:${op.read}`,
	],
	[`${key.practitionerServiceAgreement}`]: [
		`${name.practitionerServiceAgreement}:${op.read}`,
	],
	[`${key.providerPractitionerVirtualServicesAgreement}`]: [
		`${name.providerPractitionerVirtualServicesAgreement}:${op.read}`,
	],
	[`${key.operationsManual}`]: [`${name.operationManual}:${op.read}`],
	[`${key.resourcesForm}`]: [`${name.form}:${op.read}`],
	[`${key.CPSAnnualReview}`]: [`${name.CPSLetter}:${op.read}`],
	[`${key.notification}`]: [`${name.notification}:${op.read}`],
	[`${key.newsletter}`]: [`${name.newsletter}:${op.read}`],
	[`${key.ASHClearinghouse}`]: [`${name.clearinghouse}:${op.read}`],
	[`${key.compliance}`]: [`${name.compliance}:${op.read}`],
	[`${key.messageCenter}`]: [`${name.messageCenter}:${op.read}`],
	[`${key.submitAnOnlineQuestionOrComment}`]: [
		`${name.messageCenter}:${op.createUpdate}`,
	],
	[`${key.confirmUpdateInformation}`]: [
		`${name.practitionerValidation}:${op.createUpdate}`,
		`${name.providerValidation}:${op.createUpdate}`,
	],
	[`${key.newPatientSearch}`]: [`${name.newPatient}:${op.read}`],
	[`${key.existingPatientSearch}`]: [`${name.existingPatient}:${op.read}`],
	[`${key.claimsSearch}`]: [`${name.claim}:${op.read}`],
	[`${key.MNRFormSearch}`]: [`${name.MNR}:${op.read}`],
	[`${key.paymentsSearch}`]: [`${name.payment}:${op.read}`],
	[`${key.accountManagement}`]: [`${name.generalUserInformation}:${op.read}`],
	[`${key.practitionerEducationLibrary}`]: [
		`${name.practitionerEducationLibraryAboutASH}:${op.read}`,
		`${name.practitionerEducationLibraryAdminTopics}:${op.read}`,
		`${name.practitionerEducationLibraryClinicalTopics}:${op.read}`,
		`${name.practitionerEducationLibraryEvidenceEvaluationCommittee}:${op.read}`,
		`${name.practitionerEducationLibraryPatientEducation}:${op.read}`,
		`${name.practitionerEducationLibraryPolicy}:${op.read}`,
		`${name.practitionerEducationLibraryProfessionalAffairsHealthcareAdvisoryCommittee}:${op.read}`,
		`${name.practitionerEducationLibraryVideoSeries}:${op.read}`,
	],
	[`${key.providerEducationLibrary}`]: [
		`${name.providerEducationLibraryAboutASH}:${op.read}`,
		`${name.providerEducationLibraryAdminTopics}:${op.read}`,
		`${name.providerEducationLibraryClinicalTopics}:${op.read}`,
		`${name.providerEducationLibraryEvidenceEvaluationCommittee}:${op.read}`,
		`${name.providerEducationLibraryPatientEducation}:${op.read}`,
		`${name.providerEducationLibraryPolicy}:${op.read}`,
		`${name.providerEducationLibraryProfessionalAffairsHealthcareAdvisoryCommittee}:${op.read}`,
		`${name.providerEducationLibraryVideoSeries}:${op.read}`,
	],
	[`${key.reopenModificationsSearch}`]: [`${name.MNR}:${op.read}`],
	[`${key.remittanceAdviceSearch}`]: [`${name.payment}:${op.read}`],
	[`${key.ashcare}`]: [`${name.ASHCareSSO}:${op.read}`],
	[`${key.manageSubAccounts}`]: [`${name.linkedUser}:${op.read}`],
	[`${key.updateInfo}`]: [`${name.practitionerValidation}:${op.read}`],
	[`${key.practitionerStatusChangeRequest}`]: [
		`${name.practitionerStatusChangeRequest}:${op.read}`,
	],
	[`${key.emnr}`]: [`${name.EMNR}:${op.createUpdate}`],

	// Identity
	[`${key.identity}`]: [`${name.general}:${op.read}`],
};

export const retrievePageKeyWithRoute = {
	// Account
	[`/${TOP_ROUTES.account}/${PAGE_ROUTES.accountManagement}`.toLowerCase()]:
		key.accountManagement,
	[`/${TOP_ROUTES.account}/${PAGE_ROUTES.createSubAccount}`.toLowerCase()]:
		key.createSubAccount,
	[`/${TOP_ROUTES.account}/${PAGE_ROUTES.manageSubAccounts}`.toLowerCase()]:
		key.manageSubAccounts,
	[`/${TOP_ROUTES.account}/${PAGE_ROUTES.editSubAccounts}`.toLowerCase()]:
		key.editSubAccounts,

	// Resources
	[`/${TOP_ROUTES.resources}/${PAGE_ROUTES.clientSummaries}`.toLowerCase()]:
		key.clientSummary,
	[`/${TOP_ROUTES.resources}/${PAGE_ROUTES.providerServiceAgreements}`.toLowerCase()]:
		key.providerServiceAgreement,
	[`/${TOP_ROUTES.resources}/${PAGE_ROUTES.practitionerServiceAgreements}`.toLowerCase()]:
		key.practitionerServiceAgreement,
	[`/${TOP_ROUTES.resources}/${PAGE_ROUTES.providerPractitionerVirtualServicesAgreement}`.toLowerCase()]:
		key.providerPractitionerVirtualServicesAgreement,
	[`/${TOP_ROUTES.resources}/${PAGE_ROUTES.operationsManual}`.toLowerCase()]:
		key.operationsManual,
	[`/${TOP_ROUTES.resources}/${PAGE_ROUTES.forms}`.toLowerCase()]:
		key.resourcesForm,
	[`/${TOP_ROUTES.resources}/${PAGE_ROUTES.newsletters}`.toLowerCase()]:
		key.newsletter,
	[`/${TOP_ROUTES.resources}/${PAGE_ROUTES.notifications}`.toLowerCase()]:
		key.notification,
	[`/${TOP_ROUTES.resources}/${PAGE_ROUTES.valueAddedProgram}`.toLowerCase()]:
		key.valueAddedProgram,
	[`/${TOP_ROUTES.resources}/${PAGE_ROUTES.providerEducationLibrary}`.toLowerCase()]:
		key.providerEducationLibrary,
	[`/${TOP_ROUTES.resources}/${PAGE_ROUTES.practitionerEducationLibrary}`.toLowerCase()]:
		key.practitionerEducationLibrary,

	// Welcome Packet
	[`/${TOP_ROUTES.memberAgreements}`.toLowerCase()]: key.memberAgreements,

	// Help
	[`/${TOP_ROUTES.help}/${PAGE_ROUTES.faq}`.toLowerCase()]:
		key.frequentlyAskedQuestion,

	[`/${TOP_ROUTES.termsAndConditions}`.toLowerCase()]: key.termsAndCondition,
	[`/${TOP_ROUTES.privacyStatement}`.toLowerCase()]: key.privacyStatement,

	[`/${TOP_ROUTES.confirmClinicLocation}`.toLowerCase()]: key.confirmClinic,
	[`/${TOP_ROUTES.switchClinicLocation}`.toLowerCase()]: key.switchClinic,

	// EMNR
	[`/${TOP_ROUTES.forms}/${PAGE_ROUTES.eMNRSubmit}`.toLowerCase()]: key.emnr,

	// Identity
	[`/${TOP_ROUTES.identity}`.toLowerCase()]: key.identity,

	// Home
	'/': key.home,
};
